import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Tanqueos {
  id?: number;
  fecha: string;
  placa: string;
  km: number;
  tipo: string;
  taller: string;
  servicio: string;
  accion: string;
  factura: string;
  vrpagos: number;
  forma: string;
  conductor: string;
  observacion: string;
  registro?: string;
  ip?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TanqueoService {
  private apiUrl = `${environment.apiUrl}/api/tanqueos`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data, {
      withCredentials: true,
    });
  }

  update(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data, {
      withCredentials: true,
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  buscarTanqueosPorFiltros(
    placa?: string,
    fecha?: string,
    fechaFinal?: string
  ): Observable<{ tanqueos: Tanqueos[]; mensaje: string }> {
    const body: any = {};
    if (placa) body.placa = placa;
    if (fecha) body.fecha = fecha;
    if (fechaFinal) body.fechaFinal = fechaFinal;

    return this.http.post<{ tanqueos: Tanqueos[]; mensaje: string }>(
      `${this.apiUrl}/buscar`,
      body,
      { withCredentials: true }
    );
  }
}
